import * as React from 'react';

import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { RelationshipMapping } from 'src/containers/ProjectDiagram/types/data';
import { commitDiagramModel } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { isRelationshipMapping } from 'src/containers/ProjectDiagram/utils/data';
import { removeRelationshipMapping } from 'src/containers/ProjectDiagram/utils/mapping/removeRelationshipMapping';

export const useRemoveRelationshipMapping = () => {
  const diagram = useDiagram();

  return React.useCallback(
    (relationshipMappingKey: string) => {
      if (!diagram) {
        return;
      }

      const linkData = diagram.model.linkDataArray.find(
        (linkData): linkData is RelationshipMapping =>
          isRelationshipMapping(linkData) &&
          linkData.key === relationshipMappingKey
      );

      if (linkData) {
        commitDiagramModel(diagram, removeRelationshipMapping(linkData));
      }
    },
    [diagram]
  );
};
